export default __webpack_public_path__ + "static/media/icon5.374ab94a.svg";